import React from 'react';

interface RequestErrorProps {
  error?: string;
}

export function RequestError({ error }: RequestErrorProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      {error || '请求失败'}
    </div>
  );
}
